<template>
  <v-app :style="{background: $vuetify.theme.themes[theme].background}">
    <!-- Main -->
    <v-main
        :style="{background: $vuetify.theme.themes[theme].background}"
    >
      <router-view
          background-color="primary"
      />
    </v-main>
  </v-app>
</template>

<script>

export default {
  name: 'App',

  components: {
  },

  computed: {
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
    mainLogoWidth() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return '40vw'
        case 'sm':
          return '45vw'
        case 'md':
          return '30vw'
        case 'lg':
          return '23vw'
        case 'xl':
          return '18vw'
      }
      return '50vw'
    },
    mainLogoStyle() {
      const maxTransform = 100
      const minSize = 75
      if (this.offsetTop < 10) {
        return {
          maxHeight: '240px',
          marginTop: '.75em',
          borderRadius: '1em',
          padding: '1.8rem 1.3rem'
        }
      } else if (this.offsetTop > maxTransform || this.disableTransform) {
        return {
          height: '68px',
          padding: '0',
          marginTop: '-0.3rem',
          borderRadius: '.4em',
        }
      } else {
        const val = ((((maxTransform - this.offsetTop) / maxTransform) * (100 - minSize + 1)) + minSize) / 100
        return {
          transform: `scale(${val})`,
          borderRadius: '.8em'
        }
      }
    },
  },

  data: () => ({
    loading: false,
    logoAltText: 'Company Logo',
    logoSrc: '',
    iconColor: 'black',
    offsetTop: 0,
    disableTransform: false,
    searchActive: false,
    baseUrl: process.env.VUE_APP_FLX_BASE_URL,
    showLogoutDialog: false
  }),

  created() {
    this.loading = true
    // this.init()
  },

  mounted() {
    // if (this.$route.name !== 'LandingPage') {
    //   this.$router.push({name: 'LandingPage'})
    // }
  },

  updated() {
  },

  methods: {
    // async init() {
    //   const user = await new User()
    //   this.iconColor = user.iconTheme === 'dark' ? 'black' : 'white'
    //   this.logoSrc = user.logoSource
    //   this.$vuetify.theme.themes.light.primary = user.primaryColor
    //   this.$vuetify.theme.themes.light.secondary = user.secondaryColor
    //   this.$store.commit("user/SET_USER", user)
    //   this.loading = false
    // },

    // goHome() {
    //   if (!['Menu', 'Login'].includes(this.$route.name)) {
    //     this.$router.push({name: 'Menu'})
    //   }
    // },

    closeTab() {
      window.close()
    },
  }
};
</script>

<style scoped>

</style>